import { render, staticRenderFns } from "./VisitorTargets.vue?vue&type=template&id=52ada259&"
import script from "./VisitorTargets.vue?vue&type=script&lang=js&"
export * from "./VisitorTargets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports